<template>
  <component :is="Component" v-bind="props" v-on="events"/>
</template>
<script>
export default {
  props: ['Component', 'props', 'events'],
};
</script>



// WEBPACK FOOTER //
// src/renderer/grid-content.vue?68b6e607